import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Page, PageHeader } from "@/components/shared";
import NewCustomerDialog from "@/components/NewCustomerDialog";
import { Button } from "@/components/ui/button";
import { fmtNOK, STAGE_LABELS } from "@/lib/labels";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";

export default function Leads() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  const load = () => api.get("/pipeline").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const move = async (customerId, stage) => {
    await api.put(`/customers/${customerId}`, { pipeline_stage: stage });
    load();
  };

  if (!data) return <Page><p className="text-muted-foreground">Laster…</p></Page>;

  return (
    <Page>
      <PageHeader title="Salgspipeline" subtitle={`Pipelineverdi: ${fmtNOK(data.pipeline_value_mrr)}/mnd · Vektet: ${fmtNOK(data.weighted_mrr)}/mnd · ARR ${fmtNOK(data.pipeline_value_arr)}`} testid="leads-header">
        <NewCustomerDialog defaultStatus="lead" onCreated={load}
          trigger={<Button data-testid="new-lead-btn" className="bg-white text-black hover:bg-white/90"><Plus className="w-4 h-4 mr-1" /> Nytt lead</Button>} />
      </PageHeader>

      <div className="flex gap-4 overflow-x-auto pb-4 no-scrollbar" data-testid="pipeline-board">
        {data.stages.map((stage) => {
          const items = data.by_stage[stage] || [];
          const stageMrr = items.reduce((s, c) => s + (c.mrr || 0), 0);
          return (
            <div key={stage} className="min-w-[280px] w-[280px] shrink-0">
              <div className="flex items-center justify-between mb-3 px-1">
                <span className="text-sm font-semibold">{STAGE_LABELS[stage]}</span>
                <span className="text-xs text-muted-foreground bg-secondary rounded-full px-2 py-0.5">{items.length}</span>
              </div>
              <p className="label-caps mb-2 px-1">{fmtNOK(stageMrr)}/mnd</p>
              <div className="space-y-2 min-h-[100px]"
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => { const id = e.dataTransfer.getData("cid"); if (id) move(id, stage); }}>
                {items.map((c) => (
                  <motion.div key={c.id} layout draggable
                    onDragStart={(e) => e.dataTransfer.setData("cid", c.id)}
                    onClick={() => nav(`/kunder/${c.id}`)}
                    data-testid={`pipeline-card-${c.id}`}
                    className="bg-card border border-border rounded-lg p-3 cursor-pointer hover:border-white/30 transition-colors">
                    <p className="font-medium text-sm truncate">{c.legal_name}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">{c.org_number || "Uten org.nr"}</p>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-sm font-semibold text-emerald-400">{fmtNOK(c.mrr)}/mnd</span>
                      {c.probability != null && <span className="text-xs text-muted-foreground">{c.probability}%</span>}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Page>
  );
}
